import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {
  BsGeoAltFill,
  BsTelephoneFill,
  BsInstagram,
  BsTelegram,
  BsWhatsapp,
} from "react-icons/bs";
import Header from "../../../layouts/Header";
import { getOrganizationInfo } from "../api/ProfileAPIs";
import { showError } from "../../../utils/toastHelper";
import Loading from "../../../layouts/Loading";

let DefaultIcon = L.icon({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  iconSize: [16, 16],
});

L.Marker.prototype.options.icon = DefaultIcon;

const ContactPage = () => {
  const [organization, setOrganization] = React.useState([]);
  const [loading, setLoading] = useState(true);
  const [latLang, setLatLang] = useState(null);
  const [encodedAddress, setEncodedAddress] = useState("");

  React.useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const data = await getOrganizationInfo();
        console.log(data.data[0], "test");

        setOrganization(data.data[0]);
        setEncodedAddress(encodeURIComponent(data.data[0]?.address));
        setLatLang([
          parseFloat(data.data[0]?.lat),
          parseFloat(data.data[0]?.lng),
        ]);
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 400);
      } catch (err) {
        showError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrganization();
  }, []);

  if (loading) return <Loading />;
  return (
    <div className="contact-page-redesigned bg-light pt-2 mt-5">
      <div className="container py-4">
        <Header title="اطلاعات تماس " hasBack={true} />

        {/* شبکه‌های اجتماعی */}
        <div className="row text-center g-3 mb-4">
          <div className="col-4">
            <a
              href={`https://instagram.com/${organization.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
              className="social-card card bg-danger-custom  "
            >
              <div className="card-body">
                <BsInstagram size={32} />
              </div>
            </a>
          </div>
          <div className="col-4">
            <a
              href={`https://t.me/${organization.telegram}`}
              target="_blank"
              rel="noopener noreferrer"
              className="social-card card bg-primary-custom  "
            >
              <div className="card-body">
                <BsTelegram size={32} />
              </div>
            </a>
          </div>
          <div className="col-4">
            <a
              href={`https://wa.me/${organization.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="social-card card bg-success-custom  "
            >
              <div className="card-body">
                <BsWhatsapp size={32} />
              </div>
            </a>
          </div>
        </div>

        {/* کارت آدرس */}
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${latLang}`}
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card card text-center mb-3 border "
        >
          <div className="card-body">
            <BsGeoAltFill size={28} className="mb-4" />
            <h5 className="card-title m-0">{organization.address}</h5>
          </div>
        </a>

        {/* کارت تلفن */}
        <a
          href={`tel:+${organization.phone}`}
          className="contact-card card text-center mb-4 border"
        >
          <div className="card-body">
            <BsTelephoneFill size={28} className="mb-4" />
            <h5 className="card-title m-0">{organization.phone}</h5>
          </div>
        </a>
        {/* نقشه */}
        <div className="map-wrapper-redesigned card border ">
          {latLang && (
            <MapContainer
              center={latLang}
              zoom={18}
              scrollWheelZoom={true}
              className="h-100 w-100"
            >
              <TileLayer
                attribution='&copy; <a href="https://www.idmt.ir">IDMT</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={latLang}>
                <Popup>{organization.address}</Popup>
              </Marker>
            </MapContainer>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
